<template>
<!--  viewBox="0 0 20 20" fill="none" fill="#4A4A4A" xmlns="http://www.w3.org/2000/svg">-->
  <path stroke="currentColor" fill="currentColor" d="M19.3346 2.54663L17.4546 0.666626L10.0013 8.11996L2.54797 0.666626L0.667969 2.54663L8.1213 9.99996L0.667969 17.4533L2.54797 19.3333L10.0013 11.88L17.4546 19.3333L19.3346 17.4533L11.8813 9.99996L19.3346 2.54663Z"/>
</template>